<template>
  <div id="map">
  <!--In the following div the HERE Map will render-->
    <div id="mapContainer" style="height:450px;width:100%" ref="hereMap"></div>
  </div>
</template>

<script>
export default {
  name: "HereMap",
  props: ['center'],
  data() {
    return {
      platform: null
      // You can get the API KEY from developer.here.com
    };
  },
  async mounted() {
    // Initialize the platform object:
    const platform = new window.H.service.Platform({
      apikey: 'yjqZR9o7mfBORQsstucuvKDNmvfoLtekpjGvrzanTWg'
    })
    this.platform = platform;
    this.initializeHereMap();
  },
  methods: {
    addMarkerToGroup(group, coordinate) {
      var marker = new H.map.Marker(coordinate);
      // add custom data to the marker
      group.addObject(marker);
    },
    addInfoBubble(map, ui) {
      var group = new H.map.Group();

      map.addObject(group);

      var bubble =  new H.ui.InfoBubble({lat: 36.76755430454926, lng: 10.27266500674606}, { content: 
        '<div><a href="geo:36.76755430454926,10.27266500674606">Prime Shipping Agency</a>' +
        '</div><div >App N°2, 3 Rue Habib Thameur, Rades</div>'});
        this.addMarkerToGroup(group, this.center)
        // show info bubble
        ui.addBubble(bubble)
      /*
      this.addMarkerToGroup(group, this.center,
        '<div><a href="http://www.mcfc.co.uk" target="_blank">Prime Shipping Agency</a>' +
        '</div><div >App N°2, 3 Rue Habib Thameur, Rades</div>');
      // add 'tap' event listener, that opens info bubble, to the group
      /*group.addEventListener('tap', function (evt) {
        // event target is the marker itself, group is a parent event target
        // for all objects that it contains
        var bubble =  new H.ui.InfoBubble(evt.target.getGeometry(), {
          // read custom data
          content: evt.target.getData()
        });
        // show info bubble
        ui.addBubble(bubble)
      }, false);

      this.addMarkerToGroup(group, this.center,
        '<div><a href="http://www.mcfc.co.uk" target="_blank">Prime Shipping Agency</a>' +
        '</div><div >App N°2, 3 Rue Habib Thameur, Rades</div>');

      /*this.addMarkerToGroup(group, {lat:53.430, lng:-2.961},
        '<div><a href="http://www.liverpoolfc.tv" target="_blank">Liverpool</a>' +
        '</div><div >Anfield<br>Capacity: 45,362</div>');*/

    },
    initializeHereMap() { // rendering map

      const mapContainer = this.$refs.hereMap;
      const H = window.H;
      // Obtain the default map types from the platform object
      var maptypes = this.platform.createDefaultLayers();

      // Instantiate (and display) a map object:
      var map = new H.Map(mapContainer, maptypes.vector.normal.map, {
        zoom: 16,
        center: {lat: 36.76755430454926, lng: 10.27266500674606}
        // center object { lat: 40.730610, lng: -73.935242 }
      })
      //map.addObject(new H.map.Marker(this.center))

      addEventListener("resize", () => map.getViewPort().resize());
      
      
      // add behavior control
      let behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(map));
      behavior.disable(H.mapevents.Behavior.WHEELZOOM);

      // add UI
      let ui = H.ui.UI.createDefault(map, maptypes,  'fr-FR')
      this.addInfoBubble(map, ui)
      // End rendering the initial map
    }
  }
};
</script>

<style>
.H_ib_content{
  margin: 10px !important;
  min-width: 12em !important;
}
.H_ib_close, .H_imprint, .H_l_bottom.H_l_right {
  display: none !important;
}

#map {
  width: 100%;
  text-align: center;
  margin: 5% auto;
  background-color: #ccc;
}
</style>


// WEBPACK FOOTER //
// src/views/website/commons/HereMap.vue